import { render, staticRenderFns } from "./CampaignSwiper.vue?vue&type=template&id=471a7312&scoped=true&"
import script from "./CampaignSwiper.vue?vue&type=script&lang=ts&"
export * from "./CampaignSwiper.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignSwiper.vue?vue&type=style&index=0&id=471a7312&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471a7312",
  null
  
)

export default component.exports